.card {
    border: 1px solid var(--mantine-color-gray-2);
    color: var(--mantine-color-black);
    width: 100%;
}

.container {
    margin: 0 auto;

    @container (min-width: 260px) {
        & {
            width: min(
                16.25rem,
                100%
            ); /* 260px at the browser's default text size */
        }
    }

    @container (min-width: 300px) {
        & {
            width: min(
                18.75rem,
                100%
            ); /* 300px at the browser's default text size */
        }
    }

    @container (min-width: 350px) {
        & {
            width: min(
                21.875rem,
                100%
            ); /* 350px at the browser's default text size */
        }
    }
}

.logo {
    border-radius: 0 0 1.5rem 0;
    height: 40px;
    padding: var(--mantine-spacing-xxxs) var(--mantine-spacing-xxs);
    width: 112px;

    & > img {
        height: auto;
        max-width: 100%;
    }

    @container (min-width: 300px) {
        & {
            height: 52px;
            width: 148px;
        }
    }
}

.contentWrapper {
    gap: var(--mantine-spacing-xxs) !important;
    padding: var(--mantine-spacing-xxs);

    @container (min-width: 260px) {
        & {
            gap: var(--mantine-spacing-xs) !important;
            padding: var(--mantine-spacing-xs);
        }
    }

    @container (min-width: 300px) {
        & {
            gap: var(--mantine-spacing-sm) !important;
            padding: var(--mantine-spacing-sm);
        }
    }
}

.cardInfo {
    gap: var(--mantine-spacing-xs) !important;

    @container (min-width: 300px) {
        & {
            gap: var(--mantine-spacing-sm) !important;
        }
    }
}

.detailsWrapper {
    flex-wrap: wrap;
    gap: var(--mantine-spacing-xs);

    @container (min-width: 260px) {
        & {
            gap: var(--mantine-spacing-sm);
        }
    }
}

.fieldWrapper {
    gap: 0 !important;
    min-width: 6ch;
    overflow-wrap: anywhere;

    @container (min-width: 260px) {
        & {
            gap: var(--mantine-spacing-xxxs) !important;
        }
    }
}

.cardType,
.detailsValue {
    --text-fz: var(--mantine-font-size-sm);
    --text-lh: var(--mantine-line-height-sm);
    font-weight: 600;

    @container (min-width: 300px) {
        & {
            --text-fz: var(--mantine-font-size-lg);
            --text-lh: var(--mantine-line-height-lg);
        }
    }
}

.cardType {
    text-wrap: nowrap;
}

.cardTitle {
    --text-lh: var(--mantine-h2-line-height);
    --text-fz: var(--mantine-h2-font-size);
    font-weight: 600;

    @container (min-width: 300px) {
        & {
            --text-lh: var(--mantine-h1-line-height);
            --text-fz: var(--mantine-h1-font-size);
        }
    }
}

.detailsLabel {
    --text-fz: var(--mantine-font-size-sm);
    --text-lh: var(--mantine-line-height-sm);

    @container (min-width: 300px) {
        & {
            --text-fz: var(--mantine-font-size-md);
            --text-lh: var(--mantine-line-height-md);
        }
    }
}
